export const APP_STORE_URL =
  "https://apps.apple.com/ng/app/campusgenie/id6739751652";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.campusgenie.app";

/** Campaign name for the page the visitor is on: "/" -> "home", "/blog/9" -> "blog-9". */
export function currentCampaign() {
  if (typeof window === "undefined") return "site";
  const slug = window.location.pathname.replace(/^\/|\/$/g, "").replace(/\//g, "-");
  return slug || "home";
}

/** Adds attribution: Google Play reads `referrer`, the App Store reads `ct`. Shows up in each store's acquisition report. */
export function trackedStoreUrl(url, campaign = currentCampaign(), extra = {}) {
  const separator = url.includes("?") ? "&" : "?";
  if (url.includes("play.google.com")) {
    const params = new URLSearchParams({ utm_source: "website", utm_medium: "web", utm_campaign: campaign, ...extra });
    const referrer = encodeURIComponent(params.toString());
    return `${url}${separator}referrer=${referrer}`;
  }
  return `${url}${separator}ct=${encodeURIComponent(campaign)}`;
}

/** onClick for a store <a>: tags the link with the current page just before it opens. */
export function trackStoreClick(event) {
  const link = event.currentTarget;
  if (!link.dataset.baseHref) link.dataset.baseHref = link.getAttribute("href");
  link.href = trackedStoreUrl(link.dataset.baseHref);
}

/** Prefix of the clipboard token the iOS app looks for on first launch. */
export const CHALLENGE_CLIPBOARD_PREFIX = "campusgenie-challenge:";

/**
 * onClick for a store link on a shared-challenge page. Google Play carries the code in the install
 * referrer; iOS has no equivalent, so the code is also copied to the clipboard for the app to pick up.
 */
export function challengeStoreClick(code) {
  return (event) => {
    const link = event.currentTarget;
    if (!link.dataset.baseHref) link.dataset.baseHref = link.getAttribute("href");
    link.href = trackedStoreUrl(link.dataset.baseHref, "challenge", { challenge_code: code });

    try {
      navigator.clipboard?.writeText(`${CHALLENGE_CLIPBOARD_PREFIX}${code}`);
    } catch {
      /* clipboard is best-effort */
    }
  };
}
